import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { createFirestoreInstance } from 'redux-firestore';
import ReduxToastr from 'react-redux-toastr';
// import 'semantic-ui-css/semantic.min.css';
import './semantic/dist/semantic.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import './index.css';
import App from './app/layout/App';
import registerServiceWorker from './registerServiceWorker';
import { configureStore } from './app/store/configureStore';
import ScrollToTop from './app/common/util/ScrollToTop';
import ReactGA from 'react-ga';
import firebase from './app/config/firebase';

const store = configureStore();

const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  updateProfileOnLogin: false
};

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);

//Hide all console logs in production
function noop() {}
if (process.env.NODE_ENV !== 'development') {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

ReactGA.initialize('UA-141182800-1', {
  titleCase: false
  // debug: true
});

// Updated GAListener using hooks instead of legacy context
function GAListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }, [location]);

  return children;
}

let render = () => {
  const confirmOptions = {
    okText: 'OK',
    cancelText: 'Cancel'
  };
  root.render(
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <BrowserRouter>
          <GAListener>
            <ScrollToTop>
              <ReduxToastr
                timeOut={4000}
                className="aw-toastr"
                position="bottom-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                confirmOptions={confirmOptions}
              />
              <App />
            </ScrollToTop>
          </GAListener>
        </BrowserRouter>
      </ReactReduxFirebaseProvider>
    </Provider>
  );
};

if (module.hot) {
  module.hot.accept('./app/layout/App', () => {
    setTimeout(render);
  });
}

store.firebaseAuthIsReady.then(() => {
  render();
});

registerServiceWorker();
